import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * UserProtectedRoute component - gates report pages & dashboard for end-users.
 * Redirects unauthenticated users to /signin while preserving their target location.
 */
const UserProtectedRoute = () => {
  const { endUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="spinner-border text-primary" style={{ color: "#5313ca" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!endUser) {
    const redirectPath = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/signin?redirect=${redirectPath}`} replace />;
  }

  // If user has not yet set a password, restrict access only to the dashboard settings page
  if (!endUser.hasPassword) {
    const isWorkspace = location.pathname === "/workspace" || location.pathname === "/dashboard";
    if (!isWorkspace) {
      return <Navigate to="/workspace?tab=settings" replace />;
    }
  }

  return <Outlet />;
};

export default UserProtectedRoute;
